jQuery(function($) {
    const closeProductMessage = $('.close-product-message');

    closeProductMessage.each(function() {
        $(this).on('click', closeMessage);
    });
});

/**
 * Hide the parent block
 * @param {*} e 
 */
function closeMessage(e) {
    e.preventDefault();
    jQuery(this).parent().hide();
}

